export default class EngineConfigurationFileConfig {
  constructor({ title, icon, type }) {
    this.title = title;
    this.icon = icon;
    this.type = type;
  }
}
